import React, { useState } from "react";
import Swal from "sweetalert2";
import { cambioDeclaveSistema } from "../../../store/admin/thunkAdmins";
import { useDispatch } from "react-redux";
import { startLogout } from "../../../store/auth/thunks";

export const CambioClave = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [validation, setValidation] = useState({
        length: false,
        uppercase: false,
        number: false,
        specialChar: false,
        match: false,
    });

    const validatePassword = (password, confirmPassword) => {
        const validations = {
            length: password.length >= 6,
            uppercase: /[A-Z]/.test(password),
            number: /\d/.test(password),
            specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
            match: password === confirmPassword && password.length > 0,
        };
        setValidation(validations);
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        validatePassword(value, confirmPassword);
    };

    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;
        setConfirmPassword(value);
        validatePassword(password, value);
    };

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const generateRandomPassword = () => {
        const generateChar = (chars) => chars[Math.floor(Math.random() * chars.length)];
        const passwordLength = 10;
        const uppercaseChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const lowercaseChars = "abcdefghijklmnopqrstuvwxyz";
        const numbers = "0123456789";
        const specialChars = '!@#$%^&*(),.?":{}|<>';
        let password = "!Rocca.";
        password += generateChar(uppercaseChars);
        password += generateChar(lowercaseChars);
        password += generateChar(numbers);
        password += generateChar(specialChars);
        while (password.length < passwordLength) {
            const allChars = uppercaseChars + lowercaseChars + numbers + specialChars;
            password += generateChar(allChars);
        }
        setPassword(password);
        setConfirmPassword(password);
        validatePassword(password, password);
    };




   const dispatch = useDispatch();

    const changePassword = async () => {
        try {
            // Mostrar diálogo de confirmación
            const result = await Swal.fire({
                title: "¿Estás seguro?",
                text: "¿Deseas cambiar tu contraseña?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, cambiar",
                cancelButtonText: "Cancelar",
            });

            if (result.isConfirmed) {
                // Mostrar loader mientras se procesa el cambio
                Swal.fire({
                    title: "Cambiando contraseña...",
                    text: "Por favor, espera.",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                try {
                    // Simular cambio de contraseña
                    await dispatch(cambioDeclaveSistema(password));

                    // Notificar que el cambio fue exitoso
                    Swal.fire({
                        icon: "success",
                        title: "Contraseña cambiada",
                        text: "La contraseña ha sido cambiada exitosamente.",
                        showConfirmButton: false,
                        timer: 1500,
                    });

                    setTimeout(() => {
                        // Opcional: realizar acciones adicionales, como cerrar sesión
                        dispatch(startLogout());
                    }, 1500);
                } catch (error) {
                    console.error(error);

                    // Notificar error al cambiar la contraseña
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Hubo un problema al cambiar la contraseña. Por favor, inténtelo de nuevo.",
                        confirmButtonText: "Aceptar",
                    });
                }
            }
        } catch (err) {
            // Manejo de errores generales
            Swal.fire("Error", `Hubo un problema al cambiar la contraseña: ${err.message}`, "error");
        }
    };


    return (
        <div className="row">
            <div className="col-lg-6">
                <h2 className="mb-4">Cambio de Clave</h2>
                <div className="mb-3">
                    <label htmlFor="new-password" className="form-label">
                        Nueva Contraseña:
                    </label>
                    <div className="input-group">
                        <input type={showPassword ? "text" : "password"} id="new-password" className="form-control" value={password} onChange={handlePasswordChange} />
                        <button type="button" className="btn btn-outline-secondary" onClick={toggleShowPassword}>
                            {showPassword ? "👁️" : "🙈"}
                        </button>
                    </div>
                </div>
                <div className="mb-3">
                    <label htmlFor="confirm-password" className="form-label">
                        Confirmar Contraseña:
                    </label>
                    <div className="input-group">
                        <input type={showPassword ? "text" : "password"} id="confirm-password" className="form-control" value={confirmPassword} onChange={handleConfirmPasswordChange} />
                        <button type="button" className="btn btn-outline-secondary" onClick={toggleShowPassword}>
                            {showPassword ? "👁️" : "🙈"}
                        </button>
                    </div>
                </div>
                <div>
                    <p style={{ color: validation.length ? "green" : "red" }}>{validation.length ? "✔" : "✘"} Mínimo 6 caracteres</p>
                    <p style={{ color: validation.uppercase ? "green" : "red" }}>{validation.uppercase ? "✔" : "✘"} Al menos una letra mayúscula</p>
                    <p style={{ color: validation.number ? "green" : "red" }}>{validation.number ? "✔" : "✘"} Al menos un número</p>
                    <p style={{ color: validation.specialChar ? "green" : "red" }}>{validation.specialChar ? "✔" : "✘"} Al menos un carácter especial</p>
                    <p style={{ color: validation.match ? "green" : "red" }}>{validation.match ? "✔" : "✘"} Las contraseñas coinciden</p>
                </div>
                <div className="d-flex justify-content-start mt-4">
                    <button onClick={changePassword} className="btn btn-success me-2" disabled={!(validation.length && validation.uppercase && validation.number && validation.specialChar && validation.match)}>
                        Cambiar Contraseña
                    </button>
                    <button onClick={generateRandomPassword} className="btn btn-primary">
                        Generar Contraseña
                    </button>
                </div>
            </div>
        </div>
    );
};
